/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-filename-extension */
import React, { useRef } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { Container, Stack, Box, Button, Typography } from '@mui/material/';
import { styled } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useRouter } from 'next/router';
import WebFooter from '../../../src/components/web/WebFooter';
import { tokens } from '../../../src/tokens';
import WebAppBar from '../../../src/components/web/WebAppBar';

// eslint-disable-next-line no-empty-pattern

function ColorText({ children }) {
  return <span style={{ color: tokens.palette_secondary }}>{children}</span>;
}
const BlockTypo = styled(Typography)(() => ({
  fontFamily: 'play',
  opacity: 1,
  fontSize: '0.85rem',
  fontWeight: 700,
  lineHeight: '1.00rem',
  textAlign: 'center',
  paddingLeft: 0,
  whiteSpace: 'nowrap',
  color: tokens.palette_primary,
}));

const WebTypo = styled(Typography)(() => ({
  fontFamily: 'play',
  opacity: 1,
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: '1.50rem',
  textAlign: 'unset',
  paddingLeft: 0,
  whiteSpace: 'nowrap',
  color: tokens.palette_secondary,
}));
const SearxTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.6750em',
  fontWeight: 500,
  textTransform: 'none',
  color: tokens.token_typography_regular_emphasized,
}));

const Search = styled('div')(() => ({
  border: '1px solid',
  borderColor: tokens.token_search_border_grey,
  borderRadius: 24,
  maxHeight: 50,
  display: 'flex',
  alignItems: 'center',
  shadows: 2,
  '&:hover': {
    shadows: 2,
  },
}));

const SearchButton = styled(Button)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.8750em',
  fontWeight: 500,
  textTransform: 'none',
  color: tokens.token_typography_regular_emphasized,
  border: '1px, solid',
  borderColor: tokens.token_grey_50,
  backgroundColor: tokens.token_grey_50,
  '&:hover,&:focus': {
    border: '1px solid',
    borderColor: tokens.token_grey_300,
    boxShadow: '0px 1px 1px rgb(0 0 0 / 10%)',
  },
}));

export default function Home() {
  //   const router = useRouter();
  //   const searchInputRef = useRef(null);

  //   const search = (e) => {
  //     e.preventDefault();
  //     const term = searchInputRef.current.value;

  //     if (!term) return;

  //     router.push(`/search?term=${term}`);
  //   };

  return (
    <>
      <Head>
        <title>web.blockquiry</title>
        <meta name="viewport" content="width=device-width" />
      </Head>
      <Head>
        <meta content="" name="keywords" />
      </Head>
      <Head>
        <meta
          content="blockquiry's free and open-source metasearch engine powered by Searx.  Search over 70 services without tracked nor profiled"
          property="og:description"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Box>
        <WebAppBar />
      </Box>

      <Container disableGutters maxWidth="sm">
        <Box
          sx={{
            mt: '170px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Image
            width={272}
            height={64}
            src="/blockquiry272x64.png"
            alt="logo"
          />
          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <WebTypo>web</WebTypo>
            <SearxTypo>powered by Searx</SearxTypo>
          </Stack>
        </Box>

        <form action="https://10thblock.xyz/search?q=block&categories=general&language=en-US">
          <Box sx={{ flexGrow: 1, paddingTop: '20px' }}>
            <Box m={1} maxWidth="584px" flexDirection="row">
              <Search
                sx={{
                  boxShadow: 0,
                  '&:hover': { boxShadow: '1px 1px 6px rgb(32 33 36 / 28%)' },
                }}
              >
                {/* <IconButton
                  onClick={search}
                  type="submit"
                  sx={{ p: '10px', color: tokens.palette_primary }}
                  aria-label="search"
                > */}
                <IconButton
                  type="submit"
                  sx={{ p: '10px', color: tokens.palette_primary }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
                <input
                  style={{
                    width: '100%',
                    height: '35px',
                    border: 'none',
                    outline: 'none',
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontWeight: '500',
                  }}
                  //   ref={searchInputRef}
                  type="text"
                  name="q"
                  className="search"
                  maxLength={2048}
                  title="search"
                />
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                <IconButton
                  onClick={() => {
                    // if (searchInputRef.current) {
                    //   searchInputRef.current.value = '';
                    // }
                  }}
                  sx={{ p: '10px', color: tokens.palette_secondary }}
                  aria-label="directions"
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Search>
            </Box>
          </Box>

          <Stack
            paddingTop="18px"
            direction="row"
            spacing={1}
            justifyContent="center"
            maxWidth="584px"
          >
            {/* <SearchButton type="submit" onClick={search}> */}
            <SearchButton type="submit">blockquiry Search</SearchButton>
            <Tooltip title="Advanced Search Coming Soon" placement="bottom">
              <Box>
                {/* <SearchButton disabled type="submit" onClick={search}> */}
                <SearchButton disabled type="submit">
                  Advanced Search
                </SearchButton>
              </Box>
            </Tooltip>
          </Stack>
        </form>

        <Box sx={{ marginTop: '20px', padding: '5px' }}>
          {/* <BlockTypo>
            <b>
              <ColorText>b</ColorText>lock<ColorText>&nbsp;•&nbsp;</ColorText>
              quir
              <ColorText>&nbsp;•&nbsp;</ColorText>y
            </b>{' '}
            an act of asking for blockchain information.
          </BlockTypo> */}
        </Box>
      </Container>
      <WebFooter />
    </>
  );
}
